module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1600.ae47eaab.svg";